import { Stack } from "@mantine/core";
import OneClickSettings from "@/pages/Settings/components/OneClickSettings";
import OnboardingPageContainer from "./OnboardingPageContainer";

interface OneClickOnboardingProps {
  onSaveSuccess?: () => void;
  onExit?: () => void;
}

/**
 * OneClick settings view for onboarding flow
 * Wraps the OneClickSettings component
 */
const OneClickOnboarding = ({
  onSaveSuccess,
  onExit,
}: OneClickOnboardingProps) => {
  return (
    <OnboardingPageContainer onExit={onExit}>
      <Stack gap="md">
        <OneClickSettings onSaveSuccess={onSaveSuccess} />
      </Stack>
    </OnboardingPageContainer>
  );
};

export default OneClickOnboarding;
